<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.diplomes"
      add-new-text="Ajouter un diplôme"
      :live="{ endpoint: 'sas-diplomes', sasId: sas.id }"
      :icon="$getIcon('school')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>
          {{ item.universite && !estAutreUniversite(item.universite) ? getCatalogueValueById(4906, item.universite).text : item.autreUniversite }}
        </h3>
        <p class="my-0">
          {{ item.diplome && !estAutreDiplome(item.diplome) ? getCatalogueValueById(9223, item.diplome).text : item.autreDiplome }}
        </p>
        <p class="my-0" v-if="item.dateObtention">{{ item.dateObtention.substring(0, 4) }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-catalogue code="universite" v-model="item.universite" :live="liveSasDiplomes(2704, item)"> </opq-catalogue>
        <opq-text-field
          :opq-if="estAutreUniversite(item.universite)"
          code="autre-universite"
          v-model="item.autreUniversite"
          :live="liveSasDiplomes(2705, item)"
        ></opq-text-field>
        <opq-catalogue code="diplome" v-model="item.diplome" :live="liveSasDiplomes(2706, item)"> </opq-catalogue>
        <opq-text-field
          :opq-if="estAutreDiplome(item.diplome)"
          code="autre-diplome"
          v-model="item.autreDiplome"
          :live="liveSasDiplomes(2707, item)"
        ></opq-text-field>
        <opq-catalogue code="cycle-diplome" v-model="item.cycleDiplome" :live="liveSasDiplomes(2708, item)" :opq-if="estAutreDiplome(item.diplome)">
        </opq-catalogue>
        <opq-date-picker code="date-obtention" hide-day v-model="item.dateObtention" :live="liveSasDiplomes(2714, item)"></opq-date-picker>
        <opq-file-multiple code="copie-diplome" :files="item.copieDuDiplome" :live="liveSasDiplomes(2712, item)" optional> </opq-file-multiple>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import FormHybrid from "@/mixins/FormHybrid"
export default {
  mixins: [CataloguesHelper, FormHybrid],

  props: {
    sas: { type: Object }
  },

  methods: {
    liveSasDiplomes(cle, item) {
      return { endpoint: "sas-diplomes", cle: cle, fileId: item.id }
    },
    estAutreUniversite(universite) {
      return this.getCatalogueCodeById(4906, universite) == "autre"
    },
    estAutreDiplome(diplome) {
      return diplome == "JnPHZbChu9Z2CNDTrWQlPQR1EpL1R1EpL1"
    }
  }
}
</script>

<style>
</style>